<template>
  <DashboardVideo />
  <div class="container d-flex align-items-center justify-content-center z-2">
    <div class="row mobile align-content-between g-0">
      <div class="col-12 ps-3 pe-3 d-flex align-items-center justify-content-end theme-header">
        <a href="#" class="btn-back opacity-0"></a>
        <a href="#" class="m-auto"><img :src="`/img/ui-theme/` + theme.devLogo" /></a>
        <button class="btn" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasRight" aria-controls="offcanvasRight"><img src="img/ui-theme/contact-icon.svg" alt="Fullscreen"></button>
      </div>
      <div class="col-12 d-flex align-items-center justify-content-center z-2">
        <div class="row g-0">
          <div class="col-12">
            {{ bgColor }}
            <router-link
            v-for="assetType in assetTypes"
            :key="assetType.Guid"
            :to="{
              name:  componentName,
              params: {
                assetType: assetType.LinkName
              }
            }"
            class="btn-theme-menu mb-2">
              {{ assetType.ObjectName }}
            </router-link>
            <a @click="authenticate" class="btn btn-success">Generate Token</a>
          </div>
        </div>
      </div>
      <div class="col-12 d-flex align-items-end justify-content-end sticky-bottom theme-footer">
        <img :src="`/img/ui-theme/` + theme.agentLogo" class="position-relative theme-footer-logo"/>
      </div>
    </div>
  </div>
  <OffCanvas />
</template>

<script>
import DashboardVideo from "@/components/DashboardVideo.vue";
import OffCanvas from "@/components/OffCanvas.vue";
import global from '../global';
import BunnyNetService from "@/services/BunnyNetService.js";
import { unslugify } from "unslugify";
import sortArray from 'sort-array';
import { getMessaging, onMessage, getToken } from "firebase/messaging";
import { messaging } from '../firebase'

export default {
  name: "DashboardHome",
  props: ['bgColor'],
  components: {
    DashboardVideo,
    OffCanvas
  },
  data() {
    return {
      assetTypes: null,
      componentName: "AssetType",
      folderStructure: encodeURIComponent(this.theme.devFolder + '/assets/')
    }
  },
  created() {
    document.body.style.backgroundColor = this.bgColor;

    BunnyNetService.getFolders(this.folderStructure)
    .then(response => {
      // Remap array
      const menuItems = response.data.map((item) => {
        return {
          Guid: item.Guid,
          ObjectName: unslugify(item.ObjectName),
          LinkName: item.ObjectName,
          ComponentName: this.componentName,
          Path: item.Path,
          IsDirectory: item.IsDirectory,
          StorageZoneName: item.StorageZoneName
        };
      });

      // Sort array
      const customMenu = sortArray(menuItems, {
        by: ['LinkName'],
        order: 'LinkName',
        customOrders: {
          LinkName: this.theme.assetsOrder
        }
      })
      
      this.assetTypes = customMenu
    })
    .catch(error => {
      console.log(error)
    })
  },
  computed: {
  },
  setup () {
    const {theme} = global

    return {
      theme
    }
  },
  mounted() {
    const messaging = getMessaging()

    onMessage(messaging, (payload) => {
      console.log('Message on client: ', payload)

      // Customize notification here
      const notificationTitle = 'Background Message Title';
      const notificationOptions = {
        body: 'Background Message body.'
      }

      self.registration.showNotification(notificationTitle, notificationOptions);
    })
  },
  methods: {
    async authenticate() {
      this.activate()
    },
    async activate() {
      const token = await getToken(messaging, {
        vapidKey: 'BElI8qDMafo53q33QZ7HFXV-2t7qCehy2RlEBpI0Ghl9IZHo4UzYCiZx3JzMWom-g6NCKxFPerLf7yIX8yMJImM'
      })

      if(token) {
        console.log(token)
      } else {
        // Request permission
      }
    }
  },
};
</script>

